import FieldController from '../field.controller';

class DurationFieldController extends FieldController {
  constructor($scope, $q, $translate, $log, $timeout, DateTimeService, LogService, moment) {
    "ngInject";
    super($scope, $q, $translate, $log, $timeout, DateTimeService, LogService);
    this.moment = moment;
    this.DateTimeService = DateTimeService;
    this.durationMinutes = 0;
    this.durationHours = 0;
  }

  $onInit() {
    this.durationMinutes = parseInt(this.value) % 60;
    this.durationHours = Math.floor(parseInt(this.value) / 60);
    super.$onInit();

  }
  cleanDuration(){
    if (!this.durationHours) {
      this.durationHours = 0;
    }
    if (!this.durationMinutes) {
      this.durationMinutes = 0;
    }
    this.value = this.moment.duration( { minutes: this.durationMinutes, hours: this.durationHours }).as('minutes');
  }
}

export default DurationFieldController;
